import React from "react";

import { StatisticPanel } from "../../components/statistic/index.js";

export default () => <StatisticPanel />;
